/**
 * Error codes returned from API failures with their corresponding messages.
 * These codes are based on the values from the Errors.resx and Errors.ar.resx files.
 */
export const ERROR_CODES = {
  DOCUMENT_NOT_FOUND: 'DocumentNotFound',
  SERVICE_NOT_AVAILABLE: 'MP000',
  INVALID_CAPTCHA: 'MP001',
  CUSTOMER_NOT_FOUND: 'MP002',
  INVALID_PARAMETER: 'MP003',
  INVALID_APPLICATION_DATE: 'MP004',
  QUOTE_REFERENCE_NOT_FOUND: 'MP005',
  APPLICATION_NOT_FOUND: 'MP006',
  INVALID_SCHEME_VERIFICATION: 'MP007',
  UNAUTHORIZED_USER: 'MP008',
  QUOTATION_EXPIRED: 'MP009',
  WRONG_IBAN_FORMAT: 'MP010',
  UNSUPPORTED_PAYMENT_METHOD: 'MP011',
  NO_FIELD_EXISTS: 'MP012',
  APPLICATION_EXPIRED: 'MP013',
  APPLICATION_INVALID: 'MP014',
  MOBILE_ALREADY_USED: 'MP015',
  SPONSOR_NUMBER_REQUIRED: 'MP016',
  INVALID_SPONSOR_NUMBER: 'MP017',
  DATE_OF_BIRTH_REQUIRED: 'MP018',
  INVALID_DATE_OF_BIRTH: 'MP019',
  NATIONAL_ID_REQUIRED: 'MP020',
  INVALID_ID: 'MP021',
  ID_ELM_MISMATCH: 'MP022',
  MINIMUM_AGE_REQUIRED: 'MP023',
  MINIMUM_VISITOR_AGE: 'MP024',
  INVALID_PROFESSION_DETAILS: 'MP025',
  INVALID_DECLARATION_QUESTIONS: 'MP026',
  INVALID_PREVIOUS_POLICY: 'MP027',
  WRONG_OTP: 'MP028',
  INVALID_INVOICE_AMOUNT: 'MP029',
  INVALID_DECLARATIONS: 'MP030',
  INVALID_INSURANCE_COMPANY: 'MP031',
  MOBILE_NOT_OWNED_BY_ID: 'MP032',
  APPLICATION_INVOICE_NOT_FOUND: 'MP033',
  PAYMENT_ACTION_IN_PROGRESS: 'MP034',
  NATIONAL_ADDRESS_NOT_FOUND: 'national_address_not_found',
  NATIONAL_ADDRESS_NOT_FOUND_KEBAB: 'national-address-not-found',
  NATIONAL_ADDRESS_ALREADY_EXISTS: 'national_address_already_exists',
  CANCELLATION_REQUEST_ALREADY_EXISTS: 'cancellation_request_already_exists',
  BUILDING_NUMBER_INVALID_LENGTH: 'BUILDING_NUMBER_INVALID_LENGTH',
  CITY_MISSING_IN_ADDRESS: 'MP036',
  DISTRICT_MISSING_IN_ADDRESS: 'MP037',
  TOO_MANY_PLACES: 'MP038',
  PLACE_TYPE_OUT_OF_RANGE: 'MP039',
  POLICY_NOT_FOUND: 'MP040',
  SPECIALTY_REQUIRED: 'MP041',
  PAYMENT_NOT_FOUND: 'MP042',
  BILL_DETAILS_NOT_FOUND: 'MP043',
  INVALID_MOBILE_NUMBER: 'MP044',
  POLICY_HOLDER_BLOCKED: 'PolicyHolderIsBlocked',
  SUB_SPECIALITY_REQUIRED: 'Sub_speciality_Required',
  YEAR_OF_BIRTH_GRATER_ERROR: 'year_of_birth_grater_error',
  YEAR_OF_BIRTH_ERROR: 'year_of_birth_error',
  REDEMPTION_VALIDATION_ERROR: 'REDEMPTION_VALIDATION_ERROR',
  ACTIVE_PAYMENT_PENDING: 'T071',
  InvalidOTP: 'O002',
  OTP_Expired: 'O005',
  OTP_Tries_Number_Exceeded: 'O003',
  IBAN_VERIFICATION_ERROR: 'IBAN_VERIFICATION_ERROR',
  USER_BLOCKED: 'USER_BLOCKED',
  INTERNAL_SERVER_ERROR: 'INTERNAL_SERVER_ERROR',
  POLICY_RELATED_TO_ANOTHER_IDENTITY: 'policy_related_to_other_identity',
  BIRTH_DATE_NOT_CORRECT_ERROR: 'birth_date_not_correct_error',
  INVALID_RETROACTIVE_DATE: 'invalid_retroactive_date',
} as const

export type ErrorCode = (typeof ERROR_CODES)[keyof typeof ERROR_CODES]

export const NATIONAL_ADDRESS_NOT_FOUND_ERROR_CODES = [
  ERROR_CODES.NATIONAL_ADDRESS_NOT_FOUND,
  ERROR_CODES.NATIONAL_ADDRESS_NOT_FOUND_KEBAB,
] as const

export const isNationalAddressNotFoundErrorCode = (errorCode?: string) =>
  NATIONAL_ADDRESS_NOT_FOUND_ERROR_CODES.some((code) => code === errorCode)

/**
 * Longest building number the national address endpoints accept. Kept here so
 * the client-side rule and the BUILDING_NUMBER_INVALID_LENGTH message the API
 * returns for a longer value stay in sync.
 */
export const BUILDING_NUMBER_MAX_LENGTH = 10
